import { createContext, useContext, useEffect, useState } from "react";
import { EN } from "./en";

const LanguageContext = createContext(null);
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("solmoo-lang") || "en",
  );
  const [texts, setTexts] = useState(() => {
    try {
      const saved = localStorage.getItem("solmoo-lang-texts");
      return saved ? JSON.parse(saved) : {};
    } catch (e) {
      return {};
    }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = async (code) => {
    if (code === lang) return;
    setLangState(code);
    localStorage.setItem("solmoo-lang", code);
    if (code === "en") {
      setTexts({});
      localStorage.removeItem("solmoo-lang-texts");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/translate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ texts: EN, language: code }),
      });
      const j = await res.json();
      if (!j.texts) throw new Error("no texts");
      setTexts(j.texts);
      localStorage.setItem("solmoo-lang-texts", JSON.stringify(j.texts));
    } catch (e) {
      setTexts({});
      setLangState("en");
      localStorage.setItem("solmoo-lang", "en");
    }
    setLoading(false);
  };

  const t = (key) => texts[key] || EN[key] || key;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, loading }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
